<!-- 用户管理 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true">
      <el-form-item
        label="banner标题: "
        style="margin: 0 20px 0 0"
        size="small"
      >
        <el-input
          v-model="listQuery.name"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态:" style="margin: 0px 20px 0 0" size="small">
        <el-select v-model="listQuery.status" placeholder="请选择" clearable>
          <div v-for="(item, index) in stateList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>

      <el-button
        type="primary"
        @click="search"
        size="small"
        v-waves
        style="margin: 0 0px 10 0"
        >搜索</el-button
      >
    </el-form>

    <el-button
      type="primary"
      size="small"
      v-waves
      @click="handleAdd"
      style="margin: 0 20px 0 0"
      >新增</el-button
    >
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="imgUrl" slot-scope="{ row }">
          <el-image
            style="width: 60px; max-height: 60px"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          >
          </el-image>
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-tag
            type="danger"
            effect="dark"
            size="mini"
            v-if="row.status === 1"
          >
            隐藏
          </el-tag>
          <el-tag type="success" effect="dark" size="mini" v-else>
            显示
          </el-tag>
        </template>
        <template slot="disable" slot-scope="{ row }">
          <el-tag
            type="success"
            effect="dark"
            size="mini"
            v-if="row.disable == 1"
          >
            跳转
          </el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>
            不跳转
          </el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="handleEdit(row)" primary
              >修改</el-button
            >
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 表单弹窗 -->
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="dialogForm" label-width="120px">
        <el-form-item label="banner状态:">
          <el-select
            v-model="dialogForm.status"
            placeholder="请选择（默认为显示）"
            style="width: 100%"
            clearable
          >
            <div v-for="(item, index) in statusList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="banner标题" required>
          <el-input
            clearable
            v-model="dialogForm.name"
            placeholder="请输入banner标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否跳转:">
          <el-select
            v-model="dialogForm.disable"
            placeholder="请选择（默认为不跳转）"
            style="width: 100%"
            clearable
          >
            <div v-for="(item, index) in disableList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input
            clearable
            v-model="dialogForm.linkUrl"
            placeholder="请输入跳转链接"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示顺序">
          <el-input
            clearable
            v-model="dialogForm.sort"
            placeholder="请输入跳转链接"
          ></el-input>
        </el-form-item>
        <el-form-item label="banner封面" required>
          <el-input
            clearable
            v-model="dialogForm.imgUrl"
            placeholder="请输入图片地址"
          ></el-input>
          <el-upload
            name="formData"
            class="upload-demo"
            :action="action"
            :on-success="
              (response) => {
                return handleSuccess(response);
              }
            "
            multiple
            :limit="1"
            :file-list="fileList"
          >
            <el-button size="mini" type="primary" style="padding: 9px 5px"
              >上传图片</el-button
            >
            <div slot="tip" class="el-upload__tip">请上传jpg，png格式</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import { mapState } from "vuex";
import { IP } from "@/services/config.js";
import {
  selectBanner,
  deleteBanner,
  updateBanner,
  addBanner,
} from "@/services/miniApp/banner";
export default {
  components: {
    ElTable,
    // StoreToString,
  },
  // directives: {
  //   waves,
  // },
  created() {
    this.getListData();
  },
  data() {
    return {
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        name: "",
      },
      stateList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" },
      ],
      /* 表格数据 */
      tableData: [],
      storeList: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      statusList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" },
      ],
      disableList: [
        { id: 0, name: "不跳转" },
        { id: 1, name: "跳转" },
      ],
      roleVisible: false,
      navData: [],
      checkedData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo"]),
  },

  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectBanner(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    /* 搜索按钮 */
    async search() {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建Banner";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      console.log(row);
      this.dialogVisible = true;
      this.dialogName = "编辑Banner";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    handleSuccess(e) {
      console.log("handleSuccess", e);
      this.dialogForm.imgUrl = e.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },

    save() {
      //必填字段校验
      if (!this.dialogForm.name || !this.dialogForm.imgUrl) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.dialogName === "创建Banner") {
        addBanner({
          ...this.dialogForm,
        }).then((res) => {
          console.log("创建Banner", res);
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!",
            });
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.data,
            });
          }
        });
      }
      if (this.dialogName === "编辑Banner") {
        updateBanner({
          ...this.dialogForm,
        }).then((res) => {
          console.log("编辑Banner", res);
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.data,
            });
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该Banner, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteBanner({ id: row.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
